import React, { CSSProperties, FC, memo, ReactNode } from 'react'

import { SharedFacetItemProps } from '@Components/Facet/Display/Items/ItemProps'
import { Checkbox } from '@Components/FormElements/UI/Checkbox'

import styles from './Color.module.scss'
import { getColorVariables } from './color-mappings'

interface ColorItemProps extends SharedFacetItemProps {
  checked: boolean
  color: string
  count: number
  disabled: boolean
  onChange?: () => void
  text: ReactNode
}

// TODO: make color depend on the accessability scale.
export const ColorItem: FC<ColorItemProps> = memo(({
  checked,
  color,
  count,
  disabled,
  id,
  onChange,
  text,
}) => (
  <div
    className={styles.facetDisplayRoot}
    style={{
      '--checkBoxBackground': `${getColorVariables(color).background}`,
      '--checkboxBorderColor': `${getColorVariables(color).border}`,
    } as CSSProperties}
  >
    <Checkbox
      checked={checked}
      disabled={disabled}
      id={id}
      label={text}
      name={id}
      onChange={onChange}
      secondaryLabel={`(${count})`}
    />
  </div>
), (prev, next) => prev.checked === next.checked && prev.count === next.count)

